(function($){ 


  $('.shopify-section').each(function(){
    if ( $(this).find('.overlay').length ) {
        $(this).find('.overlay').parents('.shopify-section').addClass('text-shadow');
    }
  }) 

  jQuery(document).ready(function($) { 
  
 
  });

  // Product Deilvery Timer
  if ($('#cb-prd-delivery-timer').length > 0) {
    function makeTimer() {
      var endTimeDate = new Date();
      endTimeDate.setDate(endTimeDate.getDate() + 1);
      endTimeDate.setHours(0);
      endTimeDate.setMinutes(0);
      endTimeDate.setSeconds(0);
      endTimeDate.setMilliseconds(0);
      var now = new Date();
      now = (Date.parse(now) / 1000);
      endTime = (Date.parse(endTimeDate) / 1000);
  
      var timeLeft = endTime - now;
  
      var days = Math.floor(timeLeft / 86400);
      var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
      var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
      var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
      var bdays = days + 1;
      var bhours = hours + 1;
      var bminutes = minutes + 1;
      var bseconds = seconds + 1;
  
      if (hours < "10") { hours = "0" + hours; }
      if (minutes < "10") { minutes = "0" + minutes; }
      if (seconds < "10") { seconds = "0" + seconds; }
  
      $("#cb-prd-delivery-timer .cb-prd-timer-h").html(hours);
      $("#cb-prd-delivery-timer .cb-prd-timer-m").html(minutes);
      $("#cb-prd-delivery-timer .cb-prd-timer-s").html(seconds);

      
      var defaultFrom = 3;
      var defaultTo = 5;
      if ($('#delivery-days-from').length > 0) {
        defaultFrom = parseInt($('#delivery-days-from').data('delivery-days-from'));
      }
      if ($('#delivery-days-to').length > 0) {
        defaultTo = parseInt($('#delivery-days-to').data('delivery-days-to'));
      }

      var fromTimeDate = new Date();
      fromTimeDate.setDate(fromTimeDate.getDate() + defaultFrom);
      fromTimeDate.setHours(0);
      fromTimeDate.setMinutes(0);
      fromTimeDate.setSeconds(0);
      fromTimeDate.setMilliseconds(0);
      var toTimeDate = new Date();
      toTimeDate.setDate(toTimeDate.getDate() + defaultTo);
      toTimeDate.setHours(0);
      toTimeDate.setMinutes(0);
      toTimeDate.setSeconds(0);
      toTimeDate.setMilliseconds(0);
      
      $("#cb-prd-delivery-timer .cb-prd-timer-from").html(fromTimeDate.toLocaleString('en', { month: 'short' , day: 'numeric'}));
      $("#cb-prd-delivery-timer .cb-prd-timer-to").html(toTimeDate.toLocaleString('en', { month: 'short' , day: 'numeric'}));
    }
    
    makeTimer();
    setInterval(function() { makeTimer(); }, 1000);
  }

  $('.hint-description').appendTo('body')
  
 $('.hint-block .hint').on({
    mouseenter: function () {
      var dataHint = $(this).data('hint');
      var mouseX = 0, mouseY = 0;
      var xp = 0, yp = 0;
     
        $(this).mousemove(function(e){
          mouseX = e.pageX ;
          mouseY = e.pageY ; 

         $('.hint-description').each(function(){
            if ($(this).data('hint-desc') == dataHint) {
              
               $(this).addClass('hint-hovered');
              if ($(this).hasClass('hint-hovered')) {
      
              
        
                $(this).css({
                top: mouseY + 20 +'px',
                left: mouseX - $(this).outerWidth() + 30 + 'px'
                })
                 var pos = $(this).position(),
                     posX = pos.left;
                
                 console.log(posX);
                if (posX < 0 || posX == 15 ) {
                  $(this).css('left', '15px');
               }
            } else {
                $(this).removeClass('hint-hovered');
              }
            }
          })
        });
      
      
    },
    mouseleave: function () {
      $('.hint-description').removeClass('hint-hovered');
    }
});
  
})(jQuery);